import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import { ReCaptchaProvider } from "keycloakauthmodule";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <React.StrictMode>
        <BrowserRouter>
          <ReCaptchaProvider>
            <App />
          </ReCaptchaProvider>
        </BrowserRouter>
      </React.StrictMode>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
